import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerOrderLogs = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('/api/seller/order/logs-data', {
          withCredentials: true,
        });

        if (res.data && res.data.ok) {
          setShopName(res.data.shop_name || '');
          setLogs(Array.isArray(res.data.logs) ? res.data.logs : []);
        } else {
          alert(res.data?.error || '주문 로그를 불러오지 못했습니다.');
        }
      } catch (err) {
        const redirect = err?.response?.data?.redirect;
        const error = err?.response?.data?.error;
        if (redirect) {
          window.location.href = redirect;
          return;
        }
        alert(error || '주문 로그를 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loading}>로딩중...</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.topSpace}></div>
      <h2 style={styles.title}>주문 상태 변경 로그 ({shopName})</h2>

      <div style={styles.tableResponsive}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>로그 ID</th>
              <th style={styles.th}>주문 ID</th>
              <th style={styles.th}>사용자</th>
              <th style={styles.th}>기존 상태</th>
              <th style={styles.th}>변경 후 상태</th>
              <th style={styles.th}>변경 일시</th>
              <th style={styles.th}>변경자</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((row) => (
              <tr key={row.id}>
                <td style={styles.td}>{row.id}</td>
                <td style={styles.td}>
                  <a href={`/seller/order/view?id=${row.order_id}`} style={styles.link}>
                    #{row.order_id}
                  </a>
                </td>
                <td style={styles.td}>{row.nickname || ''} ({row.user_id || ''})</td>
                <td style={styles.td}>{row.old_status || ''}</td>
                <td style={styles.td}>{row.new_status || ''}</td>
                <td style={styles.td}>{row.changed_at}</td>
                <td style={styles.td}>{row.changed_by || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loading: {
    padding: '40px 0',
  },
  topSpace: {
    height: '8px',
  },
  title: {
    marginBottom: '20px',
    fontWeight: 'bold',
  },
  tableResponsive: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    fontWeight: 600,
    textAlign: 'center',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  td: {
    border: '1px solid #dee2e6',
    padding: '12px',
    textAlign: 'center',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  link: {
    color: '#0d6efd',
    textDecoration: 'none',
  },
};

export default SellerOrderLogs;